/**
 * Copyright Mántum All Rights Reserved.
 */
type PropTypes = {
    children?: React.ReactNode;
    className?: string;
    name?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    testid?: string;
    title?: string;
};

export default function Row(props: PropTypes) {
    // prettier-ignore
    const {
        className = 'block'
    } = props;

    return (
        <button
            className={`w-full truncate px-4 py-2 text-left text-gray-800 hover:bg-accent-dark ${className}`}
            data-name={props.name}
            data-testid={props.testid}
            onClick={props.onClick}
            title={props.title}
            type='button'
        >
            {props.children}
        </button>
    );
}
